import { VStack } from '@chakra-ui/react';

import FloatingCash from 'assets/brand/cash.png';
import Button from 'components/_core/Button';
import Modal from 'components/_core/Modal';
import Text from 'components/_core/Text';

import locales from './locales';

interface PendingOperationsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PendingOperationsModal = ({
  isOpen,
  onClose,
}: PendingOperationsModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <Modal.Header />
    <Modal.Body>
      <Modal.Image boxSize="144px" src={FloatingCash} />
      <Modal.Title>{locales.title}</Modal.Title>
      <Modal.Description>
        <VStack alignItems="flex-start" spacing="space-16">
          <Text>{locales.description.first}</Text>
          <Text>{locales.description.second}</Text>
        </VStack>
      </Modal.Description>
    </Modal.Body>
    <Modal.Footer justifyContent="flex-end">
      <Button onClick={onClose}>{locales.close}</Button>
    </Modal.Footer>
  </Modal>
);

export default PendingOperationsModal;
